import { reduce } from 'lodash';

export function loadFromTag(tagId) {
    // Flask will render the tag on the rendered page. This will retrieve the info
    // and set it in the data store.
    const tag = document.getElementById(tagId);
    if (!tag) {
        return;
    }

    // the values coming back are prefixed with '_'. This will remove them.
    const info = reduce(JSON.parse(tag.innerHTML), (result, value, key) => {
        const newKey = key.replace(/^_/, '');
        result[newKey] = value;
        return result;
    }, {});

    return info;
}

export function getUserInfo() {
    return loadFromTag('userInfo');
}
export async function getClientData() {
    const options = { method: 'POST' };

    try {
        const response = await fetch('/login', options);
        const result = await response.json();
        return result;
    } catch (err) {
        return err;
    }
}

export function getAppConfig() {
    return loadFromTag('appConfig');
}
